export function setupDuoRangeSliders() {
    if(document.querySelector('.duo-range-slider')) {
        Array.from(document.querySelectorAll('.duo-range-slider')).forEach(rangeSlider => {
            Array.from(rangeSlider.querySelectorAll('.duo-range-slider__range')).forEach(slider => {
                slider.oninput = updateValues;
                slider.oninput();
            });

            function updateValues() {
                const parent = this.parentNode;
                const slides = parent.getElementsByTagName('input');
                let slide1 = parseFloat(slides[0].value);
                let slide2 = parseFloat(slides[1].value);
                const displayMin = parent.querySelector('.duo-range-slider__values-min span');
                const displayMax = parent.querySelector('.duo-range-slider__values-max span');

                if(slide1 > slide2) {
                    let temp = slide2;

                    slide2 = slide1;
                    slide1 = temp;
                }

                displayMin.innerText = slide1;
                displayMax.innerText = slide2;
            }
        });
    }
}